import React from 'react';
import { Nav, Row, Col } from 'react-bootstrap';
import '../settingscommon.scss';
import '../User/user.scss';
import '../EmailProvider/emailprovider.scss';
import { Link } from 'react-router-dom';
import TwilloIcon from '../../../assets/images/TwilloIcon.svg';
import RightArrow from '../../../assets/images/right-arrow.svg';

function TextProvider() {
    return <div>
        <h1 className='page-title'>Settings</h1>
        <Nav
            className='setting-menu'
        >
            <Nav.Item>
                <Link to="/settings/user" className='nav-link'>User</Link>
            </Nav.Item>
            <Nav.Item>
                <Link to="/settings/email-provider" className='nav-link'>Email Provider</Link>
            </Nav.Item>
            <Nav.Item>
                <Link to="/settings/text-provider" className='nav-link active'>SMS Provider</Link>
            </Nav.Item>
            <Nav.Item>
                <Link to="/settings/email-signature" className='nav-link'>Email Signature</Link>
            </Nav.Item>
            {/* <Nav.Item>
                <Link to="/settings/billing" className='nav-link'>Billing</Link>
            </Nav.Item> */}
        </Nav>
        <div className='profile-sec'>
            <p>SMS provider that will be use to send messages.</p>
            <h4>Simply connect your SMS provider to get started</h4>
            <Row className='email-blocks-row'>
                <Col sm={4}>
                    <Link to="/settings/text-provider/twilio">
                        <div className='email-provider-div'>
                            <div className='icon-div'>
                                <img src={TwilloIcon} alt="icon" />
                            </div>
                            <div className='right-content'>
                                <div className='text'>
                                    <span>Twilio</span>
                                    <p>MESSAGINGX</p>
                                </div>
                                <img src={RightArrow} alt="arrow" />
                            </div>
                        </div>
                    </Link>
                </Col>
            </Row>
        </div>
    </div>;
}

export default TextProvider;
